export const ACCOUNTS_SLICE_NAME = 'accounts';

export interface Account {
  userId: string;
  studentId?: string;
  email: string;
  preferredName: string;
}

export interface Profile {
  id: string;
  name: string;
  age: number;
  incorrectHelpThreshold: number;
}

export interface AccountsSliceState {
  isLoading: boolean;
  isUpdateAccountLoading: boolean;
  isUpdateProfileLoading: boolean;
  isUpdateAppSettingsLoading: boolean;
  isDeleteAccountLoading: boolean;

  availableProfiles?: Profile[];
  currentAccount?: Account;
  currentProfile?: Profile;
  shouldSeeBeginJourney: boolean;

  formProfileName: string;
  formProfileAge: number;

  isParentInfoVisible: boolean;
}
